import {
	CustomDetailDataTypeEnum,
	CustomDetailEnum,
	DataCustomDetailTct,
	DataInvestorCustomDetailTct,
} from '@dealstack/shared/lib/generated';
import { isPersonBackedCustomDetailDataType } from '@dealstack/shared/lib/common/business/customDetails';

/** Data types that aren't a plain field, so they never belong in the profile list. */
const NON_FIELD_DATA_TYPES: CustomDetailDataTypeEnum[] = [
	CustomDetailDataTypeEnum.BANK_ACCOUNT,
	CustomDetailDataTypeEnum.FORM,
	CustomDetailDataTypeEnum.PRE_FILLABLE_FORM,
];

export interface InvestorCustomField {
	id: string;
	name: string;
	value: string | undefined;
	dataType: CustomDetailDataTypeEnum;
	archived: boolean;
	instruction: string | null;
}

export const getInvestorCustomFields = (
	mipCustomDetails: DataCustomDetailTct[] = [],
	investorCustomDetails: DataInvestorCustomDetailTct[] = []
): InvestorCustomField[] =>
	mipCustomDetails
		.filter(
			(customDetail) =>
				customDetail.isChecked &&
				customDetail.type === CustomDetailEnum.INDIVIDUAL &&
				!NON_FIELD_DATA_TYPES.includes(customDetail.dataType)
		)
		.map((customDetail) => ({
			id: customDetail.id,
			name: customDetail.name,
			dataType: customDetail.dataType,
			archived: customDetail.archived,
			instruction: customDetail.instruction,
			value: investorCustomDetails.find(
				(investorCustomDetail) => investorCustomDetail.customDetailId === customDetail.id
			)?.value,
		}));

export const getEditableInvestorCustomFields = (
	customFields: InvestorCustomField[]
): InvestorCustomField[] =>
	customFields.filter(
		({ dataType, archived }) => !archived && !isPersonBackedCustomDetailDataType(dataType)
	);
